module.exports = __webpack_public_path__ + "static/media/back_arrow.b5c36d53.svg";